import Logo from "@/components/Logo";
import Hero from "@/optionaArchive/Hero";
import { Marquee, Specialties, Method } from "@/optionaArchive/Sections";
import Programs from "@/optionaArchive/Programs";
import { About, Faq, Contact } from "@/optionaArchive/Closing";
import { EMAIL } from "@/lib/content";

const FOOTER_LINKS = [
  { href: "#specialties", label: "What I help with", tid: "footer-link-specialties" },
  { href: "#programs", label: "Programs", tid: "footer-link-programs" },
  { href: "#about", label: "About", tid: "footer-link-about" },
  { href: "#faq", label: "FAQ", tid: "footer-link-faq" },
  { href: "#contact", label: "Contact", tid: "footer-link-contact" },
];

function Footer() {
  return (
    <footer className="bg-[#070D20] border-t border-white/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-8">
        <p
          aria-hidden="true"
          className="font-displaya font-extrabold uppercase text-[clamp(3.4rem,11vw,10rem)] leading-[0.9] text-stroke-cream select-none"
        >
          Well&Truly
        </p>
        <p aria-hidden="true" className="mt-3 font-displaya font-semibold uppercase tracking-[0.34em] text-lime text-sm">
          by Akanksha
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <Logo variant="a" />
          <nav className="flex flex-wrap gap-x-7 gap-y-3 text-sm text-white/60">
            {FOOTER_LINKS.map((l) => (
              <a key={l.href} href={l.href} data-testid={l.tid} className="hover:text-lime transition-colors">
                {l.label}
              </a>
            ))}
          </nav>
          <div className="sm:text-right text-sm">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="footer-email"
              className="text-cream hover:text-lime transition-colors"
            >
              {EMAIL}
            </a>
            <p className="mt-1 text-white/50">Dubai, United Arab Emirates</p>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/40">
          <span data-testid="footer-copyright">
            © {new Date().getFullYear()} Well&Truly by Akanksha. All rights reserved.
          </span>
          <span>wellandtruly.fit</span>
        </div>
      </div>
    </footer>
  );
}

export default function OptionA() {
  return (
    <div className="grain bg-navy font-bodya text-cream" data-testid="page-option-a">
      <Hero />
      <Marquee />
      <Specialties />
      <Method />
      <Programs />
      <About />
      <Faq />
      <Contact />
      <Footer />
    </div>
  );
}
